import { cloneSystemData } from '../../plugin-contracts/system_data_contract.mjs';
function freeze(value) {
  if(value && typeof value==='object'){Object.values(value).forEach(freeze);Object.freeze(value);}return value;
}
/** Detached, read-only owner data across the order. No project or foreign paths. */
export function readOwnerSheets(contract,project,envelope) {
  const sheets=Array.isArray(envelope?.sheets) && envelope.sheets.length
    ? envelope.sheets.map(sheet=>({id:sheet.id,project:sheet.id===envelope.activeSheetId ? project : sheet.state?.project}))
    : [{id:'',project}];
  return freeze(sheets.filter(sheet=>sheet.project).map(sheet=> {
    let data=sheet.project;for(const part of contract.path)data=data?.[part];
    return {id:sheet.id,data:cloneSystemData(data===undefined ? contract.defaults : data)};
  }));
}
